export const replaceableContext: ReplaceableContext = {
  wltCode: 'WT-1039',
  wltUrl: 'https://www.b2biz.co.in',
};

export interface ReplaceableContext {
  wltCode: string;
  wltUrl: string;
}
